import { IAppConfig } from "./IAppConfig";

const sensibleDefaults:{ [k:string]:any } = {
	TUTORIAL_URL:"https://envalys.is/vrpsychlab",
	API_URL:"http://localhost:5000",
	CAN_REBUILD_SESSIONS:"false",
	CAN_DELETE_STUDIES:"false",
};

const parseBoolString = (v:any):boolean => {
	if(v === "true"){ return true; }
	return false;
};

export const getConfig = ():IAppConfig => {
	return {
		apiURL:loadVar("API_URL"),
		tutorialURL:loadVar("TUTORIAL_URL"),
		canRebuildSessions:parseBoolString(loadVar("CAN_REBUILD_SESSIONS")),
		canDeleteStudies:parseBoolString(loadVar("CAN_DELETE_STUDIES")),
	}
};

const getWindow = () => (window as any).config || {};
const getEnv = () => (process as any).env || {};

const loadVar = (name: string) => {
	const v = getEnv()[`VUE_APP_${name}`] || getWindow()[name];
	if (!v && sensibleDefaults[name] === undefined) {
		throw new Error(`Config: Unset value for '${name}'.`);
	}
	return v;
};